import { css } from "@emotion/css";
import { space } from "@octopusdeploy/design-system-tokens";
import type { EnvironmentResource } from "@octopusdeploy/octopus-server-client";
import { EnvironmentMultiSelect } from "~/components/MultiSelect/EnvironmentMultiSelect";
import type { ScopedProjectTemplatesScopeChangeTracker, ScopedProjectTemplatesScopeKey } from "./useScopedProjectTemplatesScopeChangeTracker";
interface ScopedProjectTemplateScopeEditProps {
    environments: EnvironmentResource[];
    scopeChangeTracker: ScopedProjectTemplatesScopeChangeTracker;
    scopeKey: ScopedProjectTemplatesScopeKey;
    initialEnvironmentScope: string[];
}
export default function ScopedProjectTemplateScopeEdit({ environments, scopeChangeTracker, scopeKey, initialEnvironmentScope }: ScopedProjectTemplateScopeEditProps) {
    const isScopePropertyValueUnchanged = (initialEnvironmentScope: string[], scope: string[] | undefined): boolean => {
        if (!initialEnvironmentScope || !scope) {
            return initialEnvironmentScope === scope;
        }
        if (initialEnvironmentScope.length !== scope.length) {
            return false;
        }
        return initialEnvironmentScope.every((env) => scope.includes(env));
    };
    const handleChange = (newScope: string[]) => {
        if (isScopePropertyValueUnchanged(initialEnvironmentScope, newScope)) {
            if (scopeChangeTracker.has(scopeKey)) {
                scopeChangeTracker.delete(scopeKey);
            }
        }
        else {
            scopeChangeTracker.set(scopeKey, newScope || []);
        }
    };
    const value = scopeChangeTracker.has(scopeKey) ? scopeChangeTracker.get(scopeKey) || [] : initialEnvironmentScope;
    return (<div className={cellStyles.container}>
            <EnvironmentMultiSelect environments={environments} onChange={(environmentIds) => {
            handleChange(environmentIds);
        }} value={value}/>
        </div>);
}
const cellStyles = {
    container: css({
        marginLeft: space[8],
        marginRight: space[8],
    }),
};
